"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const styles = __importStar(require("./Search.css"));
const ControlledFilter_1 = __importDefault(require("../filter/ControlledFilter"));
const Button_1 = __importDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
const SearchContextType_1 = require("./SearchContextType");
const react_flexbox_grid_1 = require("react-flexbox-grid");
const constants = __importStar(require("./constants"));
const CustomComponent_1 = __importDefault(require("../filter/custom-component/CustomComponent"));
const AdvancedFilters = (props) => {
    const { config, customFilters, customComponents } = props;
    const { state, update } = (0, react_1.useContext)(SearchContextType_1.SearchContext);
    const handleApply = () => {
        props.handleApply();
    };
    const handleCancel = () => {
        props.handleCancel();
    };
    const handleFilterChange = (id, value) => {
        update((0, SearchContextType_1.filterUpdater)(id, value));
    };
    const handleCustomFilterChange = (id, value) => {
        update((0, SearchContextType_1.customFilterUpdater)(id, value));
    };
    const renderAdvancedFiltersPanel = () => {
        return (React.createElement("div", { className: styles.secondaryFiltersPanel, "data-test-id": 'secondary-filters-panel' }, (config[constants.GuiGroups] || [])
            .filter((group) => !group[constants.GuiMain])
            .map((group) => group[constants.GuiBind] ? renderConditionalGroup(group) : renderAdvancedGroup(group, false))));
    };
    const renderAdvancedFiltersFooter = () => {
        return (React.createElement("div", { className: styles.secondaryFiltersFooter, "data-test-id": 'secondary-filters-footer' },
            React.createElement(Button_1.default, { onClick: handleCancel, kind: 'tertiary', "data-test-id": 'secondary-filters-footer-cancel', className: styles.cancelButtonFooter }, "Cancel"),
            React.createElement(Button_1.default, { onClick: handleApply, kind: 'secondary', "data-test-id": 'secondary-filters-footer-apply' }, "Apply")));
    };
    function renderConditionalGroup(secondaryGroup) {
        return (
        // @ts-ignore
        secondaryGroup[constants.GuiBind].map((bind) => {
            const bindTarget = bind[constants.GuiTarget];
            const selected = state.filters[bindTarget];
            return bind[constants.GuiValues] &&
                selected &&
                selected.length > 0 &&
                selected.every((a) => bind[constants.GuiValues].includes(a))
                ? renderAdvancedGroup(secondaryGroup, true)
                : resetSecondaryGroup(secondaryGroup);
        }));
    }
    function renderAdvancedGroup(secondaryGroup, isConditional) {
        const labelCustomId = secondaryGroup[constants.GuiLabelCustomID];
        return (React.createElement(react_flexbox_grid_1.Row, { key: 'row-' + secondaryGroup[constants.GuiLabel], "data-test-id": 'secondary-filters-panel-group' },
            React.createElement("div", { className: styles.group, key: secondaryGroup[constants.GuiLabel], "data-test-id": secondaryGroup[constants.GuiLabel] },
                React.createElement("div", { "data-test-id": secondaryGroup[constants.GuiLabel] + '-label', className: styles.groupLabel + (isConditional ? ' ' + styles.conditional : '') },
                    secondaryGroup[constants.GuiLabel],
                    labelCustomId && props.customComponents && props.customComponents[labelCustomId] && (React.createElement(CustomComponent_1.default, { "data-test-id": `label-custom-component-${labelCustomId}`, id: `${secondaryGroup[constants.GuiLabel]}-label-${labelCustomId}`, custom: props.customComponents[labelCustomId] }))),
                React.createElement("div", { className: styles.groupProperties, "data-test-id": secondaryGroup[constants.GuiLabel] + '-properties' }, secondaryGroup[constants.GuiProperties].map((item) => item[constants.GuiBind] ? renderConditionalProperty(item) : renderGroupProperty(item))))));
    }
    function renderGroupProperty(item) {
        const id = item[constants.GuiTarget] || item[constants.GuiRange][constants._id];
        const visible = item[constants.GuiVisible] !== undefined ? item[constants.GuiVisible] : true;
        return (visible && (React.createElement(react_flexbox_grid_1.Col, { xs: 12, md: 6, lg: true, xl: 4, key: 'col-' + id },
            React.createElement("div", { className: styles.groupProperty, key: id, "data-test-id": id },
                React.createElement(ControlledFilter_1.default, { id: id, key: id, property: item, customFilters: customFilters, customComponents: customComponents, onFilterChange: handleFilterChange, onCustomFilterChange: handleCustomFilterChange })))));
    }
    function renderConditionalProperty(item) {
        const itemBind = item[constants.GuiBind];
        const visible = item[constants.GuiVisible] !== undefined ? item[constants.GuiVisible] : true;
        return visible &&
            itemBind &&
            itemBind.every((bind) => {
                const bindTarget = bind[constants.GuiTarget];
                const selected = state.filters[bindTarget];
                return (bind[constants.GuiValues] &&
                    selected &&
                    selected.length > 0 &&
                    selected.every((a) => bind[constants.GuiValues].includes(a)));
            })
            ? renderGroupProperty(item)
            : resetConditionalProperty(item);
    }
    function resetSecondaryGroup(secondaryGroup) {
        secondaryGroup[constants.GuiProperties].forEach(resetConditionalProperty);
        return null;
    }
    function resetConditionalProperty(p) {
        const id = p[constants.GuiTarget];
        if (Object.keys(state.filters).filter(k => k === id).length > 0) {
            id && update((0, SearchContextType_1.filterUpdater)(id, []));
        }
        return null;
    }
    return (React.createElement("div", { id: 'secondary-filters', className: styles.secondaryFilters, "data-test-id": 'secondary-filters' },
        React.createElement(react_flexbox_grid_1.Grid, { fluid: true, className: styles.gridContainer },
            renderAdvancedFiltersPanel(),
            renderAdvancedFiltersFooter())));
};
exports.default = AdvancedFilters;
